import theme from '@styles/theme';
export default {
  quantityInputContainer: (isDip = false, error = false) => ({
    display: 'flex',
    border: `1px solid ${error ? theme.rawColors.accent700 : theme.rawColors.lightGrey500}`,
    padding: '12px 6px 11px',
    height: isDip ? 60 : 47,
    width: 'fit-content',
    alignItems: 'center'
  }),
  quantityButton: (disabled = false) => ({
    border: 'none',
    width: 24,
    height: 24,
    bg: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    // aria-disabled instead of native disabled — Firefox hides SVG inside disabled <button>
    svg: {
      'path, rect': {
        fill: disabled ? theme.rawColors.darkGrey500 : theme.rawColors.darkGrey700
      }
    },
    '&[aria-disabled="true"]': {
      cursor: 'not-allowed'
    }
  }),
  quantityInput: () => ({
    border: 'none',
    textAlign: 'center',
    bg: 'transparent',
    mozAppearance: 'textfield',
    width: 33,
    fontFamily: theme.fonts.uniform,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '100%',
    color: theme.rawColors.neutralBlack,
    fontSize: theme.fontSizes.text,
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      webkitAppearance: 'none',
      margin: 0
    },
    '&:focus': {
      border: 'none',
      outline: 'none'
    }
  }),
  quantityDipInputBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
    minWidth: 110,
    'p.subtitle': {
      color: theme.rawColors.darkGrey700,
      mb: 0
    },
    'p.caption': {
      color: theme.rawColors.darkGrey500,
      mb: 0
    }
  },
  quantityDipRow: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '3px',
    input: {
      mb: '2px'
    },
    p: {
      textAlign: 'center'
    }
  }
};